module.exports = __webpack_public_path__ + "img/DSC_2770.19905be4.png";